import {postMethod, putMethod} from '~/api'

export const post = async (personId, request) => await postMethod(`/api/privateClients/${personId}/passport`, request)
export const put = async (personId, passportId, request) =>
    await putMethod(`/api/privateClients/${personId}/passport/${passportId}`, request)
